<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
    const navItems = document.querySelectorAll('.custom-main-menu li.menu-item');

    navItems.forEach(item => {
        // Add event listener for hover
        item.addEventListener('mouseover', function () {
            document.body.classList.add('hover-active'); 
        });

        // Remove hover effect when mouse leaves
        item.addEventListener('mouseout', function () {
            document.body.classList.remove('hover-active'); 
        });
    });
});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


/* =========================================================
   FAQ - ONLY ONE QUESTION OPEN AT A TIME
   ========================================================= */

document.addEventListener(
    'click',
    function (event) {

        const clickedQuestion = event.target.closest(
            'button[class*="ai-faq__question-"]'
        );

        if (!clickedQuestion) return;

        const faqList = clickedQuestion.closest(
            'div[class*="ai-faq__list-"]'
        );

        if (!faqList) return;

        const questions = faqList.querySelectorAll(
            'button[class*="ai-faq__question-"]'
        );

        questions.forEach(function (question) {

            if (
                question !== clickedQuestion &&
                question.getAttribute('aria-expanded') === 'true'
            ) {

                /* Close previous question */
                question.setAttribute('aria-expanded', 'false');

                /* Close its answer */
                const answer = question.nextElementSibling;

                if (
                    answer &&
                    answer.matches('div[class*="ai-faq__answer-"]')
                ) {
                    answer.style.display = 'none';
                    answer.style.height = '0';
                    answer.style.maxHeight = '0';
                    answer.style.overflow = 'hidden';
                }
            }
        });

        /*
         * When the clicked question opens, remove any
         * leftover inline styles from its answer.
         */
        setTimeout(function () {

            if (
                clickedQuestion.getAttribute('aria-expanded') === 'true'
            ) {
                const clickedAnswer =
                    clickedQuestion.nextElementSibling;

                if (
                    clickedAnswer &&
                    clickedAnswer.matches(
                        'div[class*="ai-faq__answer-"]'
                    )
                ) {
                    clickedAnswer.style.removeProperty('display');
                    clickedAnswer.style.removeProperty('height');
                    clickedAnswer.style.removeProperty('max-height');
                    clickedAnswer.style.removeProperty('overflow');
                }
            }

        }, 20);

    },
    true
);





/* =========================================================
   PRODUCT FAQ
   MOVE DIRECTLY BETWEEN DESCRIPTION AND REVIEW
   ========================================================= */

(function () {

    function moveProductFaq() {

        /* Find the product FAQ */
        const faqSection = document.querySelector('#wm-faq-section');

        if (!faqSection) return;


        /* Move the entire Shopify app block */
        const faqBlock =
            faqSection.closest('.shopify-block') ||
            faqSection;


        /* Exact Ella product tab elements */
        const descriptionTab = document.querySelector(
            'product-tab #tab-description'
        );

        const reviewTab = document.querySelector(
            'product-tab #tab-review'
        );


        if (!descriptionTab) return;


        /*
         * If FAQ is already directly after Description,
         * leave it alone.
         */
        if (descriptionTab.nextElementSibling === faqBlock) {
            return;
        }


        /*
         * Insert FAQ immediately after Description.
         *
         * As Review follows Description in the Ella markup,
         * the final order becomes:
         *
         * Description
         * FAQ
         * Review
         */
        descriptionTab.insertAdjacentElement(
            'afterend',
            faqBlock
        );

    }


    /* Initial page load */
    document.addEventListener(
        'DOMContentLoaded',
        moveProductFaq
    );


    window.addEventListener(
        'load',
        moveProductFaq
    );


    /* Allow for Shopify/apps loading slightly later */
    setTimeout(moveProductFaq, 250);
    setTimeout(moveProductFaq, 750);
    setTimeout(moveProductFaq, 1500);


    /* Theme Customizer support */
    document.addEventListener(
        'shopify:section:load',
        moveProductFaq
    );

    document.addEventListener(
        'shopify:block:select',
        moveProductFaq
    );

})();



/* =========================================================
   MOBILE MENU - SECTION HEADINGS
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

    function styleMobileMenuHeadings() {

        const menu = document.querySelector('#navigation-mobile');

        if (!menu) return;

        /* Check every link in the mobile menu */
        const items = menu.querySelectorAll('a');

        items.forEach(function (item) {

            const text = item.textContent
                .replace(/\s+/g, ' ')
                .trim()
                .toUpperCase();

            /*
             * Headings we want styled blue + bold
             */
            if (
                text === 'SHOP INDOOR CLEANING' ||
                text === 'SHOP BY TASK' ||
                text === 'SPECIALIST'
            ) {
                item.classList.add('tdbs-mobile-section-heading');
            }

        });
    }


    /* Run when page first loads */
    styleMobileMenuHeadings();


    /*
     * Ella can rebuild the mobile navigation when opened,
     * so run the check again whenever the page structure changes.
     */
    const observer = new MutationObserver(function () {
        styleMobileMenuHeadings();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

});